import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter,
    EmptyState,
    BaasicButton
} from "core/components";
import { isSome } from "core/utils";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";

const ConfirmingReportListTemplate = function({ confirmingReportListViewStore }) { 
    const { 
        tableStore, 
        routes,
        queryUtility, 
        authorization, 
        } = confirmingReportListViewStore;

    return (
        <ApplicationListLayout
            store={confirmingReportListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton 
                    authorized={authorization.update} 
                    className="btn btn--base btn--primary" 
                    label={'Upload'} 
                    icon='u-icon u-icon--sml u-icon--upload--white' 
                    onClick={() => routes.uploadReport()}>
                </BaasicButton>
            </PageNavigation>
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility} showSearchFilter={true} filterVisible={true}>
                    
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="CONFIRMING_REPORT.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

ConfirmingReportListTemplate.propTypes = {
    confirmingReportListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const {
        onEdit,
        onPreview,
    } = actions;
    if (
        !isSome(onEdit) && !isSome(onPreview)
    )
        return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
            {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--preview u-icon--sml"
                        label="CONFIRMING_REPORT.LIST.BUTTON.PREVIEW"
                        onlyIcon={true}
                        onClick={() => onPreview(item)}
                    ></BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(ConfirmingReportListTemplate);